import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PersonService } from '../../services/person.service';
import { PaginatedResponse } from 'src/app/lem/models/common/paginated-response';
import { Person } from 'src/app/lem/models/person/person';
import { QuestionBase } from 'src/app/core/components/dynamic-form/models/question-base';
import { searchConfigPhysical } from '../../pages/person/form-config/search-config-physical';
import { searchConfigLegal } from '../../pages/person/form-config/search-config-legal';
import { FormConfiguration } from 'src/app/core/components/dynamic-form/models/form-config';
import { PersonType } from 'src/app/lem/models/person/person-type';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { Pagable } from 'src/app/lem/models/common/pagable';
import { Pagination } from 'src/app/common/models/pagination';

@Component({
  selector: 'app-search-person',
  templateUrl: './search-person.component.html',
  styleUrls: ['./search-person.component.css']
})
export class SearchPersonComponent implements OnInit {

  @Input() labelTitle: string;
  @Input() labelButton: string;
  @Input() required: boolean;
  @Input() forbiddenPersons: Person[];
  persons: PaginatedResponse<Person>;
  @Output() onSelect = new EventEmitter<Person>();
  @Input() listPersonID : string[];
  formFieldsPhysical: QuestionBase[] = searchConfigPhysical;
  formFieldsLegal: QuestionBase[] = searchConfigLegal;
  personType : PersonType[];
  lastSearch = null;
  personTypeSelect = null;
  resetCurrentPage: boolean = false;
  formConfiguration: FormConfiguration = {
    buttons: [
      {
        bg: "",
        width: "",
        type: "submit",
        title: "Ricerca",
        class: "btn-primary",
      },
      {
        bg: "",
        width: "",
        type: "reset",
        title: "Reset",
        class: "btn-secondary",
      }
    ]
  }
  openPanel = false;
  pagable : Pagable;


  constructor(
    private personService : PersonService,
    private viewManager : ViewManagerService,
    private cd : ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.pagable = new Pagable();
    this.viewManager.svuotaMenu();

  }

  sendSearch (value,personType, resetPage: boolean = true) {
    if (resetPage) {
      this.pagable.page = 0;
      this.resetCurrentPage = true;
      this.cd.detectChanges();
    }
    this.lastSearch = value;
    this.personService.searchPersonPaginated(this.cleanEmpty({...value , type: personType}),this.pagable).subscribe({
      next:(data)=>{
        this.persons = data;
      },
      error:()=>{}
    });
  }

  private getAllPersons (resetPage: boolean = true) {
    if(resetPage) {
      this.pagable.page = 0;
      this.resetCurrentPage = true;
      this.cd.detectChanges();
    }
    this.personService.searchPersonPaginated(undefined,this.pagable).subscribe({
      next:(data)=>{
        this.persons = data;
      },
      error:()=>{}
    });
  }


  private updatePersons(pagination?: Pagination) {
    if(pagination) {
      this.pagable.size = pagination.getItemsPerPage();
      this.pagable.page = pagination.getCurrentPage();
    }
    if (this.personTypeSelect) {
      this.sendSearch(this.lastSearch, this.personTypeSelect.id, false);
    } else {
      this.getAllPersons(false);
    }
    this.resetCurrentPage = false;
  }

  cleanEmpty (obj) {
    for (let propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj
  }

  resetForm(){
    this.personTypeSelect = null;
    // this.persons = undefined;
    this.pagable.page = 0;
    this.lastSearch = null;
  }




  onSelectPerson(person: Person){
    this.onSelect.emit(person);
    this.openPanel = false;
    this.resetForm();
  }

  changeStatusPanel(){
    this.openPanel = !this.openPanel;
    if(this.openPanel && !this.personType){
      this.personService.getAllType().subscribe((types)=>{this.personType = types;})
    }
  }

  disableById(person:Person){
    if(this.listPersonID){
      const filtered = this.listPersonID.filter(id => id === person.id);
      return filtered && filtered.length > 0;
    }
    return false;
  }

  checkPerson(person: Person): boolean {
    return !!this.forbiddenPersons?.find(el => el.id === person.id);
  }

}
